import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  handleAddRemoveSummary,
  handleSummaryChange,
} from "../../../../Redux/reducers/questionTranslationSlice";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import Add from "@mui/icons-material/Add";
import { DeleteIcon } from "../../Icons";

type Props = {
  question: any;
};

export const SummaryTab = ({ question }: Props) => {
  const dispatch = useAppDispatch();

  const isSummaryError = useAppSelector(
    ({ questionTranslation }) => questionTranslation.isSummaryError
  );
  const isPreview = useAppSelector(
    ({ questionTranslation }) => !questionTranslation.editable
  );

  return (
    <Stack gap={2} py={1}>
      {isSummaryError && (
        <Typography variant="caption" fontWeight="medium" color={"red"}>
          {isSummaryError}
        </Typography>
      )}

      <Typography variant="body1" fontWeight={"medium"}>
        Summary Translations
      </Typography>

      {question?.summaryMap?.length > 0 &&
        question?.summaryMap?.map((item: any, index: number) => {
          return (
            <Stack gap={1} key={index} direction="row">
              <Stack gap={1} flex={1}>
                <Typography variant="body1" fontWeight={"regular"}>
                  Key
                </Typography>
                <TextField
                  name={`key-${index}`}
                  fullWidth
                  value={item.key || ""}
                  onChange={(e) => {
                    dispatch(
                      handleSummaryChange({
                        index,
                        value: e.target.value,
                        section: "key",
                      })
                    );
                  }}
                />
              </Stack>

              <Stack gap={1} flex={1}>
                <Typography variant="body1" fontWeight={"regular"}>
                  Value
                </Typography>
                <TextField
                  type={"text"}
                  name={`value-${index}`}
                  fullWidth
                  value={item.value}
                  onChange={(e) => {
                    dispatch(
                      handleSummaryChange({
                        index,
                        value: e.target.value,
                        section: "value",
                      })
                    );
                  }}
                />
              </Stack>

              {!isPreview && (
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  gap={1}
                  sx={{ width: "50px" }}
                  mt={4}
                >
                  <IconButton
                    aria-label="add"
                    size="small"
                    onClick={() =>
                      dispatch(
                        handleAddRemoveSummary({
                          actionType: "add",
                          actionIndex: index,
                        })
                      )
                    }
                    color="primary"
                  >
                    <Add fontSize="small" />
                  </IconButton>

                  <IconButton
                    aria-label="delete"
                    size="small"
                    color="error"
                    onClick={() =>
                      dispatch(
                        handleAddRemoveSummary({
                          actionType: "remove",
                          actionIndex: index,
                        })
                      )
                    }
                    sx={{ height: 30, width: 30 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Stack>
              )}
            </Stack>
          );
        })}
      {!question?.summaryMap?.length && (
        <Box mt={2}>
          <Button
            variant="contained"
            onClick={() =>
              dispatch(
                handleAddRemoveSummary({
                  actionType: "add",
                  actionIndex: 0,
                })
              )
            }
          >
            Add Summary Translation
          </Button>
        </Box>
      )}
    </Stack>
  );
};
